export const AASM_STATE_IN_PROGRESS = 'in_progress';
export const AASM_STATE_CANCELLED = 'cancelled';
export const AASM_STATE_DENIED = 'denied';
export const AASM_STATE_WORKING = 'working';
export const AASM_STATE_SUSPENDED = 'suspended';
export const AASM_STATE_WAITING = 'waiting';
export const AASM_STATE_AUTO_WAITING = 'auto_waiting';
export const AASM_STATE_NOT_VALID = 'not_valid';
export const AASM_STATE_COMPLETED = 'completed';
